import { render } from "./GiftPage.vue?vue&type=template&id=5903b82e"
import script from "./GiftPage.vue?vue&type=script&lang=js"
export * from "./GiftPage.vue?vue&type=script&lang=js"

import "./GiftPage.vue?vue&type=style&index=0&id=5903b82e&lang=css"

import exportComponent from "/Users/nutsudaploysopon/Desktop/DevFinite/Octopus Co.,Ltd./Ncare/NCare-WebApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__